module.exports = __webpack_public_path__ + "img/el-ic-photos.0e1d70d1.svg";